<template>
  <Flex column w-full>
    <ConditionBuilder
      :show="showBuilder"
      :component-id="componentId"
      :condition-text="conditionText"
      :target-field-name="targetFieldName"
      @close="onConditionBuilderClose"
    ></ConditionBuilder>
    <Tabs
      :items="[
        { label: 'Condition', value: 'parsed' },
        { label: 'Source', value: 'source' },
      ]"
      :value.sync="selectedConditionTab"
    />
    <Spinner v-if="conditionLoading && selectedConditionTab === 'parsed'" class="m-2"></Spinner>
    <Span
      class="condition-placeholder"
      v-if="selectedConditionTab === 'parsed' && !conditionLoading && !conditionText"
      >Nothing to display</Span
    >
    <Span
      class="condition-placeholder"
      v-if="
        selectedConditionTab === 'parsed' &&
        !conditionLoading &&
        conditionText &&
        conditionJSON &&
        !conditionJSON.children
      "
      >Invalid XML</Span
    >
    <TreeView
      v-if="!conditionLoading && conditionText && conditionJSON && conditionJSON.children"
      :condition="conditionJSON"
      v-show="!selectedConditionTab || selectedConditionTab === 'parsed'"
    />
    <FormField
      v-show="!selectedConditionTab || selectedConditionTab === 'source'"
      :name="targetFieldName"
      label="Condition"
    >
      <CodeField
        :rules="[(v) => isValidXml(v) || 'Invalid XML']"
        required
        ref="codeField"
        @update:value="onConditionValueUpdate"
      />
    </FormField>
    <FormField>
      <Button
        color="primary"
        class="condition-button"
        @click="
          loading = true
          showBuilder = true
        "
        >Condition Builder</Button
      >
    </FormField>
  </Flex>
</template>

<script>
import FormField from '@wizer/core/components/form/FormField'
import Flex from '@wizer/core/components/flex/Flex'
import Tabs from '@wizer/core/components/tabs/Tabs'
import CodeField from '@wizer/core/components/code-field/CodeField'
import Button from '@wizer/core/components/button/Button'
import Spinner from '@wizer/core/components/spinner/Spinner'
import TreeView from '@/components/treeView/TreeView'
import ConditionService from '@/services/ConditionService'
import ConditionBuilder from '@/components/designer/ConditionBuilder'

export default {
  name: 'ConditionEditor',
  components: {
    Button,
    Flex,
    FormField,
    Tabs,
    CodeField,
    TreeView,
    Spinner,
    ConditionBuilder,
  },
  data() {
    return {
      selectedConditionTab: 'parsed',
      conditionJSON: null,
      conditionLoading: false,
      showBuilder: false,
    }
  },
  props: {
    targetFieldName: String,
    conditionText: String,
    componentId: String,
    isValidXml: Function,
  },
  methods: {
    async onConditionBuilderClose(data) {
      this.showBuilder = false
      if (data && data.targetFieldName === this.targetFieldName) {
        this.$nextTick(async () => {
          await this.onConditionValueUpdate({
            targetFieldName: this.targetFieldName,
            condition: data.condition,
          })
          await this.getLatestConditionJSON()
        })
      }
    },
    onConditionValueUpdate(data) {
      this.$emit('update:condition-text', {
        targetFieldName: this.targetFieldName,
        condition: data.condition || data,
      })
    },
    async getLatestConditionJSON() {
      try {
        this.conditionLoading = true
        if (!this.conditionText) {
          this.conditionJSON = null
        } else {
          this.conditionJSON = (
            await ConditionService.getConditionDataJSON({
              formId: this.$route.params.id,
              xmlCondition: this.conditionText,
            })
          ).data
        }
      } finally {
        this.conditionLoading = false
      }
    },
  },
  watch: {
    // A bug in codeMirror causes a code editor to be rendered incorrectly if it is hidden upon
    // initial load (e.g under a tab), this forces the field to refresh itself.
    selectedConditionTab(selectedConditionTab) {
      this.getLatestConditionJSON()
      if (selectedConditionTab === 'source') {
        const codeField = this.$refs.codeField.$children[0]
        if (codeField && codeField.$refs.editor) {
          codeField.$refs.editor.refresh()
        }
      }
    },
  },
}
</script>

<style scoped></style>
